import type { MultipleChoiceElementProps } from './MultipleChoice.types';
import { MultipleChoiceCheckbox } from './multipleChoice/Checkbox';
import { MultipleChoiceNumerals } from './multipleChoice/Numerals';
import { MultipleChoiceRadio } from './multipleChoice/Radio';
import { MultipleChoiceUnstyled } from './multipleChoice/Unstyled';

export function MultipleChoice(props: MultipleChoiceElementProps) {
  const { element, preferenceId } = props;

  const displayType = element.attrs?.data?.displayType;

  if (!displayType) {
    return null;
  }

  const propsWithPreferenceId = { ...props, preferenceId };

  switch (displayType) {
    case 'checkboxes':
      return <MultipleChoiceCheckbox {...propsWithPreferenceId} />;

    case 'radio-buttons':
      return <MultipleChoiceRadio {...propsWithPreferenceId} />;

    case 'numerals':
      return <MultipleChoiceNumerals {...propsWithPreferenceId} />;

    case 'unstyled':
      return <MultipleChoiceUnstyled {...propsWithPreferenceId} />;

    default:
      return <MultipleChoiceCheckbox {...propsWithPreferenceId} />;
  }
}
